import React, { useRef, useState, useEffect } from 'react';
import { Tooltip, Typography, TypographyProps } from '@mui/material';

interface Props extends TypographyProps {
  children: string;
}

const EllipsisWithConditionalTooltip: React.FC<Props> = ({ children, sx, ...props }) => {
  const textRef = useRef<HTMLSpanElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      setIsOverflowing(el.scrollWidth > el.clientWidth);
    }
  }, [children]);

  const textComponent = (
    <Typography
      ref={textRef}
      noWrap
      component="span"
      sx={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        display: 'block',
        width: '100%',
        ...sx,
      }}
      {...props}
    >
      {children}
    </Typography>
  );

  return isOverflowing ? <Tooltip title={children}>{textComponent}</Tooltip> : textComponent;
};

export default EllipsisWithConditionalTooltip;
